import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { Typography, TypographyProps } from '@snack-uikit/typography';
import { useMemo } from 'react';

import styles from './styles.module.scss';

type TitleProps = WithLayoutType<{
  id?: string;
  title: string;
}>;

export function Title(props: TitleProps) {
  const { id, layoutType, title } = props;

  const typographyProps: TypographyProps = useMemo(() => {
    if (layoutType === 'desktop' || layoutType === 'desktopSmall') {
      return {
        family: 'sans',
        purpose: 'headline',
        size: 's',
      };
    }

    return {
      family: 'sans',
      purpose: 'title',
      size: 'l',
    };
  }, [layoutType]);

  return (
    <div id={id}>
      <Typography className={styles.title} {...typographyProps} tag="h2">
        {title}
      </Typography>
    </div>
  );
}
